import { Handle, Position } from "@xyflow/react";
import { FlowHandle } from "./commons/flowHandle";

export default function EndNode({ id }) {
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center rounded-pill fw-medium"
      style={{
        backgroundColor: '#E5E7EB',
        color: '#1F2937',
        padding: '4px',
        fontSize: '0.875rem',
        fontFamily: 'Inter, system-ui, Segoe UI, Roboto, sans-serif',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        width: '90px',
        height: '28px',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = '#D1D5DB'}
      onMouseLeave={(e) => e.target.style.backgroundColor = '#E5E7EB'}
    >
      <FlowHandle type="target" position={Position.Left} />
      {/* <svg viewBox="0 0 6 6" aria-hidden="true" className="me-1" style={{ width: '6px', height: '6px', fill: 'currentColor', marginRight: '8px' }}>
        <circle r={3} cx={3} cy={3} />
      </svg> */}
      End
    </span>
  );
}
